// --- START PATCH: useCart hook ---
import { useContext } from "react";
import { CartContext } from "@/features/cart/context/CartContext";

export const useCart = () => {
  const ctx = useContext(CartContext);
  if (!ctx) throw new Error("useCart must be used within a CartProvider");
  return ctx;
};
// --- END PATCH: useCart hook ---
